import { ReactNode, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { APP_ROUTES_UNAUTHORIZE } from '../constants'
import { useProfile, useUserRole } from '../hooks'
import { useAccessSidebar } from '../hooks/useAccessSidebar'
import { useAppSelector } from '../store/hooks'
import { hasAccessToUpdateManage } from '../utils'

type IntakeFormRouteProps = {
  children: ReactNode
}

/**
 * Nurse intake form routes: allow sidebar nursesintake OR intake edit/manage.
 */
const IntakeFormRoute = ({ children }: IntakeFormRouteProps) => {
  const { profile, profileIsLoading } = useProfile({ isLoggedIn: true })
  const { isSuperAdmin } = useUserRole()
  const hasNurseIntakeSidebar = useAccessSidebar('nursesintake')
  const permissions = useAppSelector(state => state.user.user?.permissions)
  const hasIntakeEditManage = hasAccessToUpdateManage(permissions, 'intake', isSuperAdmin)
  const isValid = hasNurseIntakeSidebar || hasIntakeEditManage || isSuperAdmin
  const navigate = useNavigate()

  useEffect(() => {
    if (profileIsLoading || !profile) return
    if (isValid) return
    navigate(APP_ROUTES_UNAUTHORIZE, { replace: true })
  }, [isValid, navigate, profile, profileIsLoading])

  return <>{children}</>
}

export default IntakeFormRoute
